import { Button } from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'
import { Dispatch, SetStateAction } from 'react'
import { OpenLogResultModal } from '../types'

type AddResultButton = {
  setOpenModal: Dispatch<SetStateAction<OpenLogResultModal>>,
}

const AddResultButton = (props: AddResultButton) => {
  const { setOpenModal } = props

  const handleClick = () => {
    setOpenModal({ open: true, testResult: null })
  }

  return (
    <Button
      style={{ marginRight: '16px' }}
      startIcon={<AddIcon />}
      variant='contained'
      onClick={handleClick}
    >
      Log In-Office Result
    </Button>
  )
}

export default AddResultButton
